import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogData } from '../components/shared/confirm-dialog/confirm-dialog.component';
import {
  TypedConfirmDialogComponent,
  TypedConfirmDialogData,
  TypedConfirmDialogResult
} from '../components/shared/typed-confirm-dialog/typed-confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  confirm(data: ConfirmDialogData): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmDialogComponent, boolean> = this.dialog.open(
      ConfirmDialogComponent,
      {
        minWidth: '320px',
        maxWidth: 'min(480px, 92vw)',
        disableClose: data.disableClose ?? false,
        panelClass: 'ra-confirm-dialog-panel',
        ...(data.blurBackdrop && {
          backdropClass: ['cdk-overlay-dark-backdrop', 'ra-blur-backdrop']
        }),
        data: data
      }
    );

    return dialogRef.afterClosed().pipe(
      map(result => result ?? false)
    );
  }

  confirmAction(
    title: string,
    message: string,
    type: 'info' | 'warning' | 'error' | 'success' = 'info',
    confirmText: string = 'OK',
    cancelText: string = 'Cancel'
  ): Observable<boolean> {
    return this.confirm({
      title,
      message,
      confirmText,
      cancelText,
      type
    });
  }

  /**
   * Opens a typed-confirmation dialog that requires the user to type a specific
   * phrase before the confirm button becomes active. Suitable for destructive
   * operations where accidental clicks must be prevented.
   */
  typedConfirm(data: TypedConfirmDialogData): Observable<TypedConfirmDialogResult> {
    const dialogRef: MatDialogRef<TypedConfirmDialogComponent, TypedConfirmDialogResult> =
      this.dialog.open(TypedConfirmDialogComponent, {
        minWidth: '360px',
        maxWidth: 'min(560px, 92vw)',
        disableClose: false,
        panelClass: 'ra-typed-confirm-dialog-panel',
        data
      });

    return dialogRef.afterClosed().pipe(
      map(result => result ?? { confirmed: false, selectedOption: null })
    );
  }
}
